import { create } from '@thoughtspot/logger/esm/logger';
import { TSToChartEvent } from '@thoughtspot/ts-chart-sdk';
import _ from 'lodash';
import { sendMessage } from '../../../services/post-message-event-dispatcher';
import { mapCustomChartConfigToSDKConfig } from '../../../utils/custom-chart-config-adaptor.util';
import { mapSDKQueryToDataQueryInput } from '../../../utils/data-query.util';
import { OtelOp } from '../../../utils/otel-operations';
import { childContext, startSpan } from '../../../utils/tracer';
import { validateGetDataForQueryEventPayloadObject } from '../../chart-to-ts/data-events/util';
const logger = create('ts-to-chart > event-callbacks > get-data-query');
export const triggerGetDataQueriesFromAxisConfig = (commonProps, eventProps, emitEvent) => {
    const { iFrameWindow, appUrl } = commonProps;
    return sendMessage(iFrameWindow, {
        eventType: TSToChartEvent.GetDataQuery,
        payload: {
            config: eventProps.chartConfig,
        },
    }, appUrl)
        .then(res => {
        try {
            validateGetDataForQueryEventPayloadObject(res.data);
        }
        catch (err) {
            logger.error('Error in validating data queries', err);
            throw err;
        }
        logger.debug('Data Queries', res.data.queries);
        return res.data.queries;
    })
        .catch(err => {
        logger.error('Error in fetch data queries from the app', err);
        throw err;
    });
};
export const fetchDataForQueries = async (commonProps, eventProps, emitEvent) => {
    const { chartModel, getAnswerDataByQuery, setChartConfigQueries, otelContext = null, otelEnabled = false, } = eventProps;
    const columnProperties = chartModel.vizProp.columnProperties || [];
    const sdkChartConfig = mapCustomChartConfigToSDKConfig(chartModel.config.customChartConfig, chartModel.columns, columnProperties);
    const dataFetchSpan = startSpan(OtelOp.NETWORK_DATA_FETCH, otelContext, otelEnabled, { 'data_fetch.config_count': sdkChartConfig?.length ?? 0 });
    const dataFetchCtx = childContext(otelContext, dataFetchSpan);
    let queries = [];
    const pmQueryStart = Date.now();
    const pmQuerySpan = startSpan(OtelOp.NETWORK_POSTMESSAGE_QUERY, dataFetchCtx, otelEnabled, { 'postmessage.event_type': TSToChartEvent.GetDataQuery });
    try {
        queries = await triggerGetDataQueriesFromAxisConfig(commonProps, { chartConfig: sdkChartConfig }, emitEvent);
        pmQuerySpan.setAttribute('postmessage.duration_ms', Date.now() - pmQueryStart);
        pmQuerySpan.end();
    }
    catch (err) {
        pmQuerySpan.setStatus({ code: 2 });
        pmQuerySpan.end();
        dataFetchSpan.setStatus({ code: 2 });
        dataFetchSpan.end();
        logger.error('Error in fetching data queries', err);
        return Promise.reject(err);
    }
    setChartConfigQueries(queries);
    const dataQueryInput = mapSDKQueryToDataQueryInput(queries);
    if (_.isNil(dataQueryInput) || _.isEmpty(dataQueryInput.queries)) {
        logger.error('No queries found to fetch data');
        dataFetchSpan.end();
        return Promise.resolve([]);
    }
    logger.debug('making data calls with query', dataQueryInput);
    try {
        const result = await getAnswerDataByQuery(dataQueryInput, dataFetchCtx);
        dataFetchSpan.end();
        return result;
    }
    catch (err) {
        dataFetchSpan.setStatus({ code: 2 });
        dataFetchSpan.end();
        throw err;
    }
};
//# sourceMappingURL=index.js.map